module.exports = __webpack_public_path__ + "static/media/customer-mcCain.505e7b5c.png";